import React from 'react';
import { Form, Input } from 'formik-semantic-ui';
import { Header, Input as Input2, Icon, Popup } from 'semantic-ui-react';
import { copyToClipboard } from '../../utils';

const isPhoneNo = str => {
  // Digits and spaces only is enough but not too much validation
  return /^(?=.*\d)[\d ]+$/.test(str);
};

export const CustomerContact = ({
  _handleSubmit,
  customer,
  setFieldValue,
  redactedForGDPR,
  editEmail,
  copyDetails
}) => {
  // TDTODO improve mobile number validation https://github.com/google/libphonenumber
  return (
    <>
      <div>
        {copyDetails && !redactedForGDPR ? (
          <>
            <Header as="h3" style={{ float: 'left' }}>
              <Icon name="address card" />
              Contact
              {' - '}
            </Header>
            <Popup
              content="Copy contact details to clipboard"
              style={{ float: 'right' }}
              trigger={
                <svg
                  data-icon-name="contentCopyIcon"
                  viewBox="0 0 24 24"
                  width="22"
                  height="22"
                  aria-hidden="true"
                  sandboxuid="0"
                  onClick={() => {
                    let txt = '';

                    if (customer.title) txt += customer.title + ' ';
                    txt += customer.forename + ' ' + customer.surname + '\n';
                    txt += '\n';

                    if (customer.address_line1)
                      txt += customer.address_line1 + '\n';
                    if (customer.address_line2)
                      txt += customer.address_line2 + '\n';
                    if (customer.address_city)
                      txt += customer.address_city + '\n';
                    if (customer.address_country_region)
                      txt += customer.address_country_region + '\n';
                    if (customer.address_county)
                      txt += customer.address_county + '\n';
                    if (customer.address_postcode)
                      txt += customer.address_postcode + '\n';
                    txt += '\n';

                    if (customer.email) txt += customer.email + '\n';
                    if (customer.home_tel_no)
                      txt += customer.home_tel_no + '\n';
                    if (customer.mob_tel_no) txt += customer.mob_tel_no + '\n';

                    copyToClipboard(txt);
                  }}
                >
                  <path fill="none" d="M0 0h24v24H0z" sandboxuid="0"></path>
                  <path
                    d="M16 20H5V6H3v14c0 1.1.9 2 2 2h11v-2zm4-4V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2zm-2 0H9V4h9v12z"
                    sandboxuid="0"
                  ></path>
                </svg>
              }
            />
          </>
        ) : (
          <Header as="h3">
            <Icon name="address card" />
            Contact
          </Header>
        )}
      </div>
      <br />
      <Form.Children>
        <label>
          <b>Email</b>
        </label>
        <br />
        <Input2
          value={customer?.email}
          style={{ width: '250px' }}
          name="email"
          disabled={true}
        />
        <Input
          inputProps={{ placeholder: 'First Name' }}
          label="*First Name"
          name="forename"
          validate={value => (value ? null : 'Required')}
        />
        <Input
          inputProps={{ placeholder: 'Last Name' }}
          label="*Last Name"
          name="surname"
          validate={value => (value ? null : 'Required')}
        />
        {!redactedForGDPR && (
          <>
            <Input
              inputProps={{ placeholder: 'Enter Street number and name' }}
              label="*Address line 1"
              name="address_line1"
              validate={value => (value ? null : 'Required')}
            />
            <Input
              inputProps={{ placeholder: 'Address line 2 (optional)' }}
              label="Address line 2"
              name="address_line2"
            />
            <Input
              width={6}
              inputProps={{ placeholder: 'Enter City or Town' }}
              label="*City or Town"
              name="address_city"
              validate={value => (value ? null : 'Required')}
            />
            <Input
              width={6}
              inputProps={{ placeholder: 'Enter County or Region' }}
              label="Select County / Region"
              name="address_county"
            />
            <Input
              width={6}
              inputProps={{ placeholder: 'Enter Postcode' }}
              label="*Postcode"
              name="address_postcode"
            />
            {/*<Input
              width={8}
              inputProps={{
                icon: 'mail',
                iconPosition: 'left',
                placeholder: 'Email'
              }}
              label="*Email"
              name="email"
              validate={value => {
                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))
                  return 'Not a valid email address';
                return value ? null : 'Required';
              }}
            />*/}
            <Input
              width={8}
              inputProps={{
                icon: 'phone',
                iconPosition: 'left'
              }}
              label="Home tel. no."
              name="home_tel_no"
            />
            <Input
              width={8}
              inputProps={{
                icon: 'phone',
                iconPosition: 'left'
              }}
              label="*Mobile tel. no."
              name="mob_tel_no"
              validate={value =>
                value && isPhoneNo(value)
                  ? null
                  : !value
                  ? 'Required'
                  : 'Not a valid phone number'
              }
            />
          </>
        )}
      </Form.Children>
    </>
  );
};
